import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

// App Check debug mode: solo activo en desarrollo local (localhost)
// Genera un token en la consola para registrarlo en Firebase Console > App Check
if (import.meta.env.DEV) {
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize App Check (protects Firestore and Auth from bots)
const recaptchaKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
if (recaptchaKey) {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(recaptchaKey),
    isTokenAutoRefreshEnabled: true,
  });
} else {
  console.warn('App Check deshabilitado: VITE_RECAPTCHA_SITE_KEY no configurada.');
}

// Initialize Analytics (solo si measurementId está disponible)
if (import.meta.env.VITE_FIREBASE_MEASUREMENT_ID) {
  getAnalytics(app);
}

// Initialize Auth
export const auth = getAuth(app);

// Initialize Firestore (usamos la inicialización estándar para evitar cuelgues 
// infinitos de promesas getDocs() causados por el tabManager en React 18)
export const db = getFirestore(app);

export default app;